import {
  adminReduxConstants,
  authConstants,
  globalConstants,
} from "../../constants";
import { adminService } from "../../services/admin.service";
import { custom, success } from "./utilities";
import { customToast } from "../../shared/utility";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import { systemActions, propertyActions } from "../actions";

const {
  GET_DASHBOARD_DATA,
  GET_SUB_ADMINS,
  ADD_SUB_ADMIN,
  DELETE_SUB_ADMIN,
  GET_CUSTOMERS,
  GET_CUSTOMER_DETAILS,
  GET_AGENTS,
  GET_APPROVALS,
  GET_AGENT_DETAILS,
  GET_AGENT_PROPERTIES,
  GET_COUNTRIES_SETTINGS,
  GET_COUNTRIES_SETTINGS_DETAILS,
  UPDATE_NOTIFICATION_STATUS,
  GET_ADMIN_NOTIFICATIONS,
  GET_FAQS,
  UPDATE_FAQS,
  GET_CUSTOMERS_EXPORT_ALL_DATA,
  GET_SUB_ADMINS_EXPORT_ALL_DATA,
  GET_AGENTS_APPROVALS_EXPORT_ALL_DATA,
  GET_AGENTS_CURRENT_LIST_EXPORT_ALL_DATA,
} = adminReduxConstants;

const GetDashboardData = (filters) => (dispatch) => {
  dispatch(custom(GET_DASHBOARD_DATA, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .GetDashboardData(filters)
    .then(
      (response) => dispatch(success(response.data, GET_DASHBOARD_DATA)),
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_DASHBOARD_DATA, globalConstants.SPINNER_DIACTIVATE))
    );
};
const getSubAdmins = (data) => (dispatch) => {
  dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getSubAdmins(data)
    .then(
      (response) => dispatch(success(response.data, GET_SUB_ADMINS)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_DIACTIVATE))
    );
};
const resendAdminEmail = (id) => (dispatch) => {
  dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .resendAdminEmail(id)
    .then(
      (response) => customToast(response.msg, SUCCESS_TOAST),
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const addSubAdmin = (data, successFunc) => (dispatch) => {
  dispatch(custom(ADD_SUB_ADMIN, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .addSubAdmin(data)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(ADD_SUB_ADMIN, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateSubAdmin = (data, successFunc) => (dispatch) => {
  dispatch(custom(ADD_SUB_ADMIN, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updateSubAdmin(data)
    .then(
      (response) => {
        successFunc(response.data);
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(ADD_SUB_ADMIN, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateAdminPassword = (data, successFunc) => (dispatch) => {
  dispatch(
    custom(authConstants.CHANGE_PASSWORD, globalConstants.SPINNER_ACTIVATE)
  );
  return adminService
    .updateAdminPassword(data)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(
        custom(
          authConstants.CHANGE_PASSWORD,
          globalConstants.SPINNER_DIACTIVATE
        )
      )
    );
};

const deleteSubAdmin = (id, successFunc) => (dispatch) => {
  dispatch(custom(DELETE_SUB_ADMIN, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .deleteSubAdmin(id)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(DELETE_SUB_ADMIN, globalConstants.SPINNER_DIACTIVATE))
    );
};

const getCustomers = (data) => (dispatch) => {
  dispatch(custom(GET_CUSTOMERS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getCustomers(data)
    .then(
      (response) => dispatch(success(response.data, GET_CUSTOMERS)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_CUSTOMERS, globalConstants.SPINNER_DIACTIVATE))
    );
};
const getCustomerDetails = (id) => (dispatch) => {
  dispatch(custom(GET_CUSTOMER_DETAILS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getCustomerDetails(id)
    .then(
      (response) => dispatch(success(response.data, GET_CUSTOMER_DETAILS)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_CUSTOMER_DETAILS, globalConstants.SPINNER_DIACTIVATE))
    );
};
const customerStatusUpdate = (id, successFunc) => (dispatch) => {
  dispatch(custom(GET_CUSTOMERS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .customerStatusUpdate(id)
    .then(
      (response) => {
        customToast(response.msg, SUCCESS_TOAST);
        successFunc();
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_CUSTOMERS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const getApprovedAgents = (data) => (dispatch) => {
  dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getApprovedAgents(data)
    .then(
      (response) => dispatch(success(response.data, GET_AGENTS)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
    );
};
const getAgentsApprovals = (data) => (dispatch) => {
  dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getAgentsApprovals(data)
    .then(
      (response) => dispatch(success(response.data, GET_APPROVALS)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
    );
};
const getAgentDetails = (id) => (dispatch) => {
  dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getAgentDetails(id)
    .then(
      (response) => dispatch(success(response.data, GET_AGENT_DETAILS)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateApprovalStatus = (data, successFunc) => (dispatch) => {
  dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updateApprovalStatus(data)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateAgentStatus = (id, successFunc) => (dispatch) => {
  dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updateAgentStatus(id)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateAdminStatus = (id, successFunc) => (dispatch) => {
  dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updateAdminStatus(id)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const getAgentProperties = (id, body) => (dispatch) => {
  dispatch(custom(GET_AGENT_PROPERTIES, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getAgentProperties(id, body)
    .then(
      (response) => dispatch(success(response.data, GET_AGENT_PROPERTIES)),
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENT_PROPERTIES, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updatePropertyStatus = (id, successFunc, body) => (dispatch) => {
  dispatch(custom(GET_AGENT_PROPERTIES, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updatePropertyStatus(id, body)
    .then(
      (response) => {
        if (response?.data?.needsConfirmation) {
          dispatch(propertyActions.setPropertyId(id));
          dispatch(systemActions.setIsConfirmationModal(true));
        } else {
          successFunc();
          customToast(response.msg, SUCCESS_TOAST);
        }
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENT_PROPERTIES, globalConstants.SPINNER_DIACTIVATE))
    );
};

const getCountriesSettings = (data) => (dispatch) => {
  dispatch(custom(GET_COUNTRIES_SETTINGS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getCountriesSettings(data)
    .then(
      (response) => dispatch(success(response.data, GET_COUNTRIES_SETTINGS)),
      (error) => customToast(error[0], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(
        custom(GET_COUNTRIES_SETTINGS, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const getCountriesSettingsDetails = (id) => (dispatch) => {
  dispatch(
    custom(GET_COUNTRIES_SETTINGS_DETAILS, globalConstants.SPINNER_ACTIVATE)
  );
  return adminService
    .getCountriesSettingsDetails(id)
    .then(
      (response) =>
        dispatch(success(response.data, GET_COUNTRIES_SETTINGS_DETAILS)),
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(
        custom(
          GET_COUNTRIES_SETTINGS_DETAILS,
          globalConstants.SPINNER_DIACTIVATE
        )
      )
    );
};

const createCountrySettings = (data, successFunc) => (dispatch) => {
  dispatch(
    custom(GET_COUNTRIES_SETTINGS_DETAILS, globalConstants.SPINNER_ACTIVATE)
  );
  return adminService
    .createCountrySettings(data)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(
        custom(
          GET_COUNTRIES_SETTINGS_DETAILS,
          globalConstants.SPINNER_DIACTIVATE
        )
      )
    );
};
const updateCountrySettings = (data, successFunc) => (dispatch) => {
  dispatch(
    custom(GET_COUNTRIES_SETTINGS_DETAILS, globalConstants.SPINNER_ACTIVATE)
  );
  return adminService
    .updateCountrySettings(data)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(
        custom(
          GET_COUNTRIES_SETTINGS_DETAILS,
          globalConstants.SPINNER_DIACTIVATE
        )
      )
    );
};

const deleteCountrySetting = (id, successFunc) => (dispatch) => {
  dispatch(custom(GET_COUNTRIES_SETTINGS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .deleteCountrySetting(id)
    .then(
      (response) => {
        successFunc();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(
        custom(GET_COUNTRIES_SETTINGS, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const getAdminNotifications = () => (dispatch) => {
  dispatch(custom(GET_ADMIN_NOTIFICATIONS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getAdminNotifications()
    .then(
      (response) => {
        dispatch(success(response.data, GET_ADMIN_NOTIFICATIONS));
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(
        custom(GET_ADMIN_NOTIFICATIONS, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const updateAdminNotificationStatus = (id) => (dispatch) => {
  dispatch(
    custom(UPDATE_NOTIFICATION_STATUS, globalConstants.SPINNER_ACTIVATE)
  );
  return adminService
    .updateNotificationStatus(id)
    .then(
      (response) => {
        dispatch(getAdminNotifications());
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(
        custom(UPDATE_NOTIFICATION_STATUS, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const getFAQs = () => (dispatch) => {
  dispatch(custom(GET_FAQS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .getAllFAQs()
    .then(
      (response) => {
        dispatch(success(response.items, GET_FAQS));
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_FAQS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateFAQs = (data) => (dispatch) => {
  dispatch(custom(UPDATE_FAQS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updateFAQs(data)
    .then(
      (response) => {
        dispatch(getFAQs());
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => {
        customToast(error[1], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(UPDATE_FAQS, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updatePagination = (data, type) => (dispatch) =>
  dispatch(custom(data, type));

const getAllCustomersItemsForExport = (data) => {
  return (dispatch) => {
    dispatch(custom(GET_CUSTOMERS, globalConstants.SPINNER_ACTIVATE));
    return adminService
      .getCustomers(data)
      .then(
        (response) =>
          dispatch(
            success(response.data?.items, GET_CUSTOMERS_EXPORT_ALL_DATA)
          ),
        (error) => {
          customToast(error[1], ERROR_TOAST);
        }
      )
      .finally(() =>
        dispatch(custom(GET_CUSTOMERS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

const getAllSubAdminsItemsForExport = (data) => {
  return (dispatch) => {
    dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_ACTIVATE));
    return adminService
      .getSubAdmins(data)
      .then(
        (response) =>
          dispatch(
            success(response.data?.items, GET_SUB_ADMINS_EXPORT_ALL_DATA)
          ),
        (error) => {
          customToast(error[1], ERROR_TOAST);
        }
      )
      .finally(() =>
        dispatch(custom(GET_SUB_ADMINS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

const getApprovedAgentsItemsForExport = (data) => {
  return (dispatch) => {
    dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
    return adminService
      .getApprovedAgents(data)
      .then(
        (response) =>
          dispatch(
            success(
              response.data?.items,
              GET_AGENTS_CURRENT_LIST_EXPORT_ALL_DATA
            )
          ),
        (error) => {
          customToast(error[1], ERROR_TOAST);
        }
      )
      .finally(() =>
        dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

const getAgentsApprovalsItemsForExport = (data) => {
  return (dispatch) => {
    dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
    return adminService
      .getAgentsApprovals(data)
      .then(
        (response) =>
          dispatch(
            success(response.data?.items, GET_AGENTS_APPROVALS_EXPORT_ALL_DATA)
          ),
        (error) => {
          customToast(error[1], ERROR_TOAST);
        }
      )
      .finally(() =>
        dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

const resetAllExportItems = (type) => {
  return (dispatch) => {
    dispatch(success([], type));
  };
};

const updateAgentPaymentStatus = (id, body, successFunc) => (dispatch) => {
  dispatch(custom(GET_AGENTS, globalConstants.SPINNER_ACTIVATE));
  return adminService
    .updateAgentPaymentStatus(id, body)
    .then(
      (response) => {
        if (response?.data?.needsConfirmation) {
          dispatch(systemActions.setSelectedRowId(id));
          dispatch(systemActions.setIsConfirmationModal(true));
        } else {
          successFunc();
          customToast(response.msg, SUCCESS_TOAST);
        }
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(GET_AGENTS, globalConstants.SPINNER_DIACTIVATE))
    );
};

export const adminActions = {
  GetDashboardData,
  getSubAdmins,
  updatePagination,
  addSubAdmin,
  updateSubAdmin,
  deleteSubAdmin,
  updateAdminPassword,
  getCustomers,
  customerStatusUpdate,
  getCustomerDetails,
  getApprovedAgents,
  getAgentsApprovals,
  getAgentDetails,
  updateApprovalStatus,
  updateAgentStatus,
  getAgentProperties,
  updatePropertyStatus,
  getCountriesSettings,
  createCountrySettings,
  getCountriesSettingsDetails,
  updateCountrySettings,
  resendAdminEmail,
  updateAdminStatus,
  deleteCountrySetting,
  getAdminNotifications,
  updateAdminNotificationStatus,
  getFAQs,
  updateFAQs,
  resetAllExportItems,
  getAllCustomersItemsForExport,
  getAllSubAdminsItemsForExport,
  getApprovedAgentsItemsForExport,
  getAgentsApprovalsItemsForExport,
  updateAgentPaymentStatus,
};
